import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CheckCircleIcon, ClockIcon, TagIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  const included = ['El mapa completo para construir tu flujo de ingresos digital en 48 horas', 'Las 3 herramientas exactas que funcionan en el mercado latino', 'El guión de cierre para que te digan "sí" antes de terminar la demo', 'Plantillas listas para usar (sin programar)', 'Acceso inmediato y de por vida'];
  const handleCheckout = () => {
    // Track AddToCart event before redirect
    trackAddToCart();
    window.location.href = 'https://www.consejossimples.com/cart/53395621347661:1';
  };
  return <section id="offer" className="w-full bg-slate-900 py-20 px-4" data-id="element-53">
      <div className="max-w-4xl mx-auto" data-id="element-54">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-55">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold mb-4" data-id="element-56">
            Tu Plan de Escape del{' '}
            <span className="text-red-400" data-id="element-57">Sistema Tradicional</span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-300" data-id="element-58">
            Usando Inteligencia Artificial Aplicada
          </p>
        </motion.div>

        <motion.div className="bg-gradient-to-br from-slate-800 to-slate-700 border-2 border-gold-400 rounded-2xl p-8 md:p-12 shadow-2xl" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-59">
          {/* Sale Badge */}
          <div className="flex justify-center mb-4" data-id="element-60">
            <div className="inline-flex items-center gap-2 bg-red-500 text-white px-6 py-2 rounded-full font-bold text-lg" data-id="element-61">
              <TagIcon className="w-5 h-5" data-id="element-62" />
              ¡REBAJA! Antes $18 USD
            </div>
          </div>

          {/* Price */}
          <div className="text-center mb-8" data-id="element-63">
            <p className="text-gray-400 text-lg mb-4" data-id="element-64">Inversión única de:</p>

            {/* Argentine Pesos */}
            <div className="mb-4" data-id="element-65">
              <div className="flex items-center justify-center gap-3 mb-2" data-id="element-66">
                <span className="text-5xl md:text-6xl font-heading font-bold text-gold-400" data-id="element-67">
                  $11.000
                </span>
                <span className="text-2xl text-gray-300" data-id="element-68">ARS</span>
              </div>
              <p className="text-gray-400 text-sm" data-id="element-69">Pesos Argentinos</p>
            </div>

            {/* Divider */}
            <div className="flex items-center justify-center gap-4 my-4" data-id="element-70">
              <div className="h-px bg-gray-600 w-20" data-id="element-71"></div>
              <span className="text-gray-500" data-id="element-72">o</span>
              <div className="h-px bg-gray-600 w-20" data-id="element-73"></div>
            </div>

            {/* US Dollars with strikethrough old price */}
            <div className="mb-4" data-id="element-74">
              <div className="flex items-center justify-center gap-2 mb-2" data-id="element-75">
                <span className="text-2xl md:text-3xl font-heading line-through text-gray-500" data-id="element-76">
                  $18
                </span>
                <span className="text-gray-500" data-id="element-77">→</span>
              </div>
              <div className="flex items-center justify-center gap-3 mb-2" data-id="element-78">
                <span className="text-5xl md:text-6xl font-heading font-bold text-teal-400" data-id="element-79">
                  $6.36
                </span>
                <span className="text-2xl text-gray-300" data-id="element-80">USD</span>
              </div>
              <p className="text-gray-400 text-sm" data-id="element-81">Dólares</p>
            </div>

            <p className="text-xl text-gold-400 font-semibold mt-4" data-id="element-82">
              Menos de lo que cuesta una cena
            </p>
          </div>

          {/* What's Included */}
          <div className="mb-8" data-id="element-83">
            <h3 className="font-heading text-2xl font-bold text-center mb-6" data-id="element-84">
              Qué está incluido:
            </h3>
            <ul className="space-y-4" data-id="element-85">
              {included.map((item, index) => <motion.li key={index} className="flex items-start gap-3" initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.1 * index
            }} data-id="element-86">
                  <CheckCircleIcon className="w-6 h-6 text-gold-400 flex-shrink-0 mt-1" data-id="element-87" />
                  <span className="text-lg text-gray-200" data-id="element-88">{item}</span>
                </motion.li>)}
            </ul>
          </div>

          {/* Guarantee */}
          <div className="bg-teal-900/30 border border-teal-500/50 rounded-lg p-6 mb-8" data-id="element-89">
            <p className="text-center text-lg text-gray-200" data-id="element-90">
              <span className="font-semibold text-teal-400" data-id="element-91">
                Sin riesgos, sin rellenos.
              </span>{' '}
              Solo lo que necesitas para empezar a generar ingresos este fin de
              semana.
            </p>
          </div>

          {/* CTA */}
          <div className="text-center" data-id="element-92">
            <Button size="large" className="w-full md:w-auto mb-4" onClick={handleCheckout} data-id="element-93">
              Accede al Curso de Sueldo Digital
            </Button>
            <div className="flex items-center justify-center gap-2 text-gray-400" data-id="element-94">
              <ClockIcon className="w-5 h-5" data-id="element-95" />
              <span data-id="element-96">Empieza este fin de semana</span>
            </div>
          </div>
        </motion.div>

        {/* Final Urgency */}
        <motion.p className="text-center text-xl text-gray-300 mt-12 leading-relaxed" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-97">
          ¿Qué harías con{' '}
          <span className="text-gold-400 font-semibold" data-id="element-98">
            $500 USD extra al mes
          </span>
          ? El manual paso a paso para lograrlo con IA está a un clic de
          distancia.
        </motion.p>
      </div>
    </section>;
}